import { slideUp } from '@globals/utils/functions';
import * as CryptoJS from 'crypto-js';

function setCookie(name: string, value: string, days?: number): void {
	let expires = '';

	if (days) {
		const date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = '; expires=' + date.toUTCString();
	}

	document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/';
}

function getCookie(name: string): string | null {
	const nameEQ = name + '=';
	const ca = document.cookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) === 0) {
			return decodeURIComponent(c.substring(nameEQ.length, c.length));
		}
	}
	return null;
}

function handleNotificationBarVisibilityCookie(content = '', createCookie = false): void {
	const notificationBar = document.querySelector<HTMLElement>('.notification-bar');

	const hash = CryptoJS.MD5(content).toString();
	const name = `notification_bar_visibility_${hash}`;
	const isVisible = getCookie(name);
	const valHidden = 'hidden';

	if (valHidden === isVisible) {
		notificationBar?.classList.add('dismissed', 'hidden');
	} else if (createCookie) {
		setCookie(name, valHidden, 1);
	}
}

/**
 * Sets up the dismiss functionality for a notification bar.
 * When the element with class '.notification-bar__dismiss' is clicked,
 * the element with class '.notification-bar' will be hidden.
 */
function handleNotificationBarDismiss(): void {
	const notificationBar = document.querySelector<HTMLElement>('.notification-bar');

	const dismissButton = notificationBar?.querySelector<HTMLButtonElement>(
		'.notification-bar__dismiss'
	);
	const notificationContent =
		notificationBar?.querySelector<HTMLElement>('.notification-bar__text');

	const notificationText = notificationContent ? notificationContent.textContent : null;
	const trimText = notificationText?.replace(/\s\s+/g, ' ').trim();

	// Check if both elements exist before proceeding.
	// This prevents errors if the elements are not found in the DOM.
	if (dismissButton && notificationBar) {
		dismissButton.addEventListener('click', () => {
			notificationBar.classList.add('dismissed');
			slideUp(notificationBar);
			handleNotificationBarVisibilityCookie(trimText, true);
		});
		handleNotificationBarVisibilityCookie(trimText);
	}
}
document.addEventListener('DOMContentLoaded', handleNotificationBarDismiss);
